// extracted by mini-css-extract-plugin
export default {"root":"TombstoneWrapper-root-985398839fcd30956e3a1b187950e707","border":"TombstoneWrapper-border-be98ae5a25e5c1588bd965562c848880"};